import { Component, OnInit, Output, EventEmitter, ViewChild, Sanitizer, ElementRef, OnDestroy } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { request } from 'http';
//import { RequestMetadata, PagedResult } from '../../../../lib/ng-crud-table';
import { MatTableDataSource, fadeInContent } from '@angular/material';
import { DataSource } from '@angular/cdk/table';
import { MatDialog, MatDialogConfig, PageEvent, MatPaginator } from '@angular/material';
import { Row } from 'lib/ng-data-table';
import { SelectItem, formatDate, lastDateFunc } from 'lib/common';
import { rsltTypeInTitle } from 'src/app/shared/functions/title';
import { environment } from 'src/environments/environment';
import { Chart, ChartType, ChartOptions } from 'chart.js';
import { ChartsModule } from 'ng2-charts';
import { CustomStatsConfig } from 'src/app/shared/models/Configuration/CustomStatsConfig';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonFilter } from 'src/app/shared/models/Common/common-filter';
import { DataFilter } from 'lib/ng-data-table/base';
import { DemoService } from 'src/app/shared/demo.service';

@Component({
  selector: 'app-voice-quality-statistics-pie-chart',
  templateUrl: './voice-quality-statistics-pie-chart.component.html',
  styleUrls: ['./voice-quality-statistics-pie-chart.component.scss', '../../graphics/analysis/analysis.component.scss',
    '../../../../lib/dt-toolbar/dt-toolbar.component.css',
    '../../../../lib/styles/icons.css',
    '../../../../lib/styles/context-menu.css',
    '../../../../lib/styles/list-menu.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class VoiceQualityStatisticsPieChartComponent implements OnInit, OnDestroy {
  baseUrl: string;
  url: string;
  //public chartNameRTD: string = "";
  //public chartNameOWD: string = "";
  //public chartNamePDD: string = "";
  //public chartNameSNR: string = "";
  pieChartVQT: Chart;
  pieChartPOLQA: Chart;
  pieChartPOLQAv3: Chart;
  pieChartVBA: Chart;
  showLegend: boolean = false;
  getLegend: boolean = false;
  voiceQualityConfigList = [];
  expandedElement: PeriodicElement | null;
  voiceQualityConfig = new CustomStatsConfig();

  clearAllFiltersAction: boolean = true;
  actionsMessage: string = 'Actions';
  modifyFiltersMessage: string = 'Modify filters';
  clearFiltersMessage: string = 'Clear all filters';
  isFilters: boolean = true;
  hasFilters: boolean;

  rsltType: string = "VoiceQualityStatsPieChart";

  rsltTypeTS = '-1';
  TSSelected: number;

  AutoRefreshInfo: any;

  title: string = "Voice Quality Statistics";
  staticScreen = false;
  @Output() childTitleEvent = new EventEmitter();

  isLoading = true;

  interval;

  private subscriptions: Subscription[] = [];
  filterEventIDSelected = false;
  delColSelected = false;
  columnName = "VQuad_Timestamp";
  TimestampType = 1;

  //public pieChartOptionsRTD: ChartOptions = {
  //  responsive: true,
  //  legend: {
  //    position: 'left',
  //  },
  //  plugins: {
  //    datalabels: {
  //      formatter: (value, ctx) => {
  //        const label = ctx.chart.data.labels[ctx.dataIndex];
  //        return label;
  //      },
  //    },
  //  }
  //};
  //public pieChartLabelsRTD: string[] = [];
  //public pieChartDataRTD: number[] = [300, 500, 100, 200];
  //public pieChartTypeRTD: ChartType = 'pie';
  //public pieChartLegendRTD = true;
  ////public pieChartPlugins = [pluginDataLabels];
  //public pieChartColorsRTD = [
  //  {
  //    backgroundColor: ['rgba(0, 0, 255)', 'rgba(0, 0, 255)', 'rgba(0, 0, 255)', 'rgba(0, 0, 255)'],
  //  },
  //];

  //public pieChartOptionsOWD: ChartOptions = {
  //  responsive: true,
  //  legend: {
  //    position: 'left',
  //  },
  //  plugins: {
  //    datalabels: {
  //      formatter: (value, ctx) => {
  //        const label = ctx.chart.data.labels[ctx.dataIndex];
  //        return label;
  //      },
  //    },
  //  }
  //};
  //public pieChartLabelsOWD: string[] = [];
  //public pieChartDataOWD: number[] = [300, 500, 100, 200];
  //public pieChartTypeOWD: ChartType = 'pie';
  //public pieChartLegendOWD = true;
  ////public pieChartPlugins = [pluginDataLabels];
  //public pieChartColorsOWD = [
  //  {
  //    backgroundColor: ['rgba(255,255,0)', 'rgba(255,255,0)', 'rgba(255,255,0)', 'rgba(255,255,0)'],
  //  },
  //];

  //public pieChartOptionsPDD: ChartOptions = {
  //  responsive: true,
  //  legend: {
  //    position: 'left',
  //  },
  //  plugins: {
  //    datalabels: {
  //      formatter: (value, ctx) => {
  //        const label = ctx.chart.data.labels[ctx.dataIndex];
  //        return label;
  //      },
  //    },
  //  }
  //};
  //public pieChartLabelsPDD: string[] = [];
  //public pieChartDataPDD: number[] = [300, 500, 100, 200];
  //public pieChartTypePDD: ChartType = 'pie';
  //public pieChartLegendPDD = true;
  ////public pieChartPlugins = [pluginDataLabels];
  //public pieChartColorsPDD = [
  //  {
  //    backgroundColor: ['rgba(0, 0, 255)', 'rgba(0, 0, 255)', 'rgba(0, 0, 255)', 'rgba(0, 0, 255)'],
  //  },
  //];

  //public pieChartOptionsSNR: ChartOptions = {
  //  responsive: true,
  //  legend: {
  //    position: 'left',
  //  },
  //  plugins: {
  //    datalabels: {
  //      formatter: (value, ctx) => {
  //        const label = ctx.chart.data.labels[ctx.dataIndex];
  //        return label;
  //      },
  //    },
  //  }
  //};
  //public pieChartLabelsSNR: string[] = [];
  //public pieChartDataSNR: number[] = [300, 500, 100, 200];
  //public pieChartTypeSNR: ChartType = 'pie';
  //public pieChartLegendSNR = true;
  ////public pieChartPlugins = [pluginDataLabels];
  //public pieChartColorsSNR = [
  //  {
  //    backgroundColor: ['rgba(0, 0, 255)', 'rgba(0, 0, 255)', 'rgba(0, 0, 255)', 'rgba(0, 0, 255)'],
  //  },
  //];

  dataSource: any[];
  dataSourceExpanded = [];
  dataSourcePolqa: any[];
  dataSourceExpandedPolqa = [];
  dataSourceVBA: any[];
  dataSourceExpandedVBA = [];
  lstPieChartSetting: [] = [];

  vqtColumnsToDisplay = ['RowExpand', 'VQuad_Location', 'AVGOfPESQ_LQ', 'MAXOfPESQ_LQ', 'MINOfPESQ_LQ', 'AVGOfPESQ_MOS', 'MAXOfPESQ_MOS', 'MINOfPESQ_MOS', 'AVGOfPESQ_WB'
    , 'MAXOfPESQ_WB', 'MINOfPESQ_WB', 'AVGOfPESQ_Score', 'MAXOfPESQ_Score', 'MINOfPESQ_Score', 'AVGOfPESQ_Average_offset', 'AVGOfPESQ_Max_Offset', 'AVGOfPESQ_Min_Offset', 'AVGOfPESQ_Std_Deviation_Offset'
    , 'AVGOfAverage_Jitter', 'AVGOfNumber_All_clipping', 'AVGOfProportion_All_clipping', 'AVGOfDuration_ALL_Clipping', 'AVGOfMean_Duration_ALL_Clipping', 'AVGOfduration_hangover'
    , 'AVGOfNumber_of_hangover', 'TotalRecord'];

  pesqExpandedColumns = ['VQuad_PhoneID', 'AVGOfPESQ_LQ', 'MAXOfPESQ_LQ', 'MINOfPESQ_LQ', 'AVGOfPESQ_MOS', 'MAXOfPESQ_MOS', 'MINOfPESQ_MOS', 'AVGOfPESQ_WB'
    , 'MAXOfPESQ_WB', 'MINOfPESQ_WB', 'AVGOfPESQ_Score', 'MAXOfPESQ_Score', 'MINOfPESQ_Score', 'AVGOfPESQ_Average_offset', 'AVGOfPESQ_Max_Offset', 'AVGOfPESQ_Min_Offset', 'AVGOfPESQ_Std_Deviation_Offset'
    , 'AVGOfAverage_Jitter', 'AVGOfNumber_All_clipping', 'AVGOfProportion_All_clipping', 'AVGOfDuration_ALL_Clipping', 'AVGOfMean_Duration_ALL_Clipping', 'AVGOfduration_hangover'
    , 'AVGOfNumber_of_hangover', 'TotalRecord'];

  //// Polqa
  polqaColumnsToDisplay = ['RowExpand', 'VQuad_Location', 'AVGOfPOLQA_v3', 'MAXOfPOLQA_v3', 'MINOfPOLQA_v3', 'AVGOfPOLQA_Score', 'MAXOfPOLQA_Score', 'MINOfPOLQA_Score'
    , 'AVGOfEModel_Polqa', 'MAXOfEModel_Polqa', 'MINOfEModel_Polqa', 'AVGOfSpeech_Level_Diff', 'MAXOfSpeech_Level_Diff', 'MINOfSpeech_Level_Diff', 'AVGOfSNR_Diff'
    , 'MAXOfSNR_Diff', 'MINOfSNR_Diff', 'AVGOfJitter_Ave', 'MAXOfJitter_Max', 'MINOfJitter_Min', 'AVGOfASR_Ref'
    , 'AVGOfASR_Deg', 'AVGOfNumber_of_Utterance', 'TotalRecord'];

  polqaExpandedColumns = ['VQuad_PhoneID', 'AVGOfPOLQA_v3', 'MAXOfPOLQA_v3', 'MINOfPOLQA_v3', 'AVGOfPOLQA_Score', 'MAXOfPOLQA_Score', 'MINOfPOLQA_Score'
    , 'AVGOfEModel_Polqa', 'MAXOfEModel_Polqa', 'MINOfEModel_Polqa', 'AVGOfSpeech_Level_Diff', 'MAXOfSpeech_Level_Diff', 'MINOfSpeech_Level_Diff', 'AVGOfSNR_Diff'
    , 'MAXOfSNR_Diff', 'MINOfSNR_Diff', 'AVGOfJitter_Ave', 'MAXOfJitter_Max', 'MINOfJitter_Min', 'AVGOfASR_Ref'
    , 'AVGOfASR_Deg', 'AVGOfNumber_of_Utterance', 'TotalRecord'];
  expandedElementPolqa: PeriodicElement | null;

  ///// VBA
  vbaColumnsToDisplay = ['RowExpand', 'VQuad_Location', 'AVGOfMOS_CQ', 'MAXOfMOS_CQ', 'MINOfMOS_CQ', 'AVGOfRFactor', 'MAXOfRFactor', 'MINOfRFactor', 'TotalRecord'];

  vbaExpandedColumns = ['VQuad_PhoneID', 'AVGOfMOS_CQ', 'MAXOfMOS_CQ', 'MINOfMOS_CQ', 'AVGOfRFactor', 'MAXOfRFactor', 'MINOfRFactor', 'TotalRecord'];
  expandedElementVBA: PeriodicElement | null;

  constructor(private _Activatedroute: ActivatedRoute, private _router: Router, private service: DemoService, private commonFilterService: CommonFilterService, private http: HttpClient, private dialog: MatDialog) {
    this.baseUrl = environment.urlAddress + '/api/';

    _Activatedroute.params.subscribe(val => {
      this.rsltType = _Activatedroute.snapshot.url[1].path;

      this.parentEvent();
    });
    this.commonFilterService.setNonFiltersScreen(this.staticScreen);

    this.commonFilterService.TSType.subscribe(res => {//TsType
      this.TimestampType = res;
      if (this.TimestampType >= 2)//
        this.TimestampType = 1;//Change VQT to VQuad Timestamp if screen doesn't belongs to VQT types nd send as TSTYpe in filtering - IMP
      this.columnName = "VQuad_Timestamp";
      if (this.TimestampType == 2) {
        this.columnName = "VQT_Timestamp";
      }
      else if (this.TimestampType == 0) {
        this.columnName = "Call_Timestamp";
      }
    });

    const _broadSublisten = this.commonFilterService.listen.subscribe(res => {
      if (res === 'onlVQTStatInit' && !this.filterEventIDSelected)
        this.LoadVQT('');
      if (this.filterEventIDSelected)
        this.filterEventIDSelected = false;
    });
    this.subscriptions.push(_broadSublisten);

    this.commonFilterService.isFilters$.subscribe(res => {
      this.isFilters = res;
    });

    //Do Refresh
    const _broadSubRefresh = this.commonFilterService.componentMethodCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.LoadVQT('');
      }
    );
    this.subscriptions.push(_broadSubRefresh);

    const _broadSubDeleteFilter = this.commonFilterService.DeleteFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        if (res !== '') {//IMP IMP
          this.LoadVQT(res);
        }
      }
    );
    this.subscriptions.push(_broadSubDeleteFilter);

    const _broadSubAllGeneralFilter = this.commonFilterService.AllGeneralFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log('AllGeneralFilter')
        this.AllGeneralFilter = res;
        if (!this.delColSelected && !this.clearAllFiltersBool && this.AllGeneralFilter.length > 0)
          this.LoadVQT('');

        //reset here
        if (this.delColSelected)
          this.delColSelected = false;
        if (this.clearAllFiltersBool)
          this.clearAllFiltersBool = false;
      }
    );
    this.subscriptions.push(_broadSubAllGeneralFilter);

    //const _broadSubGeneralDFFilter = this.commonFilterService.GeneralFilterDF.subscribe(res => {
    //  //console.log('GeneralDFFilter')
    //  this.filters = res;
    //});
    //this.subscriptions.push(_broadSubGeneralDFFilter);
    const _broadSubGeneralFilter = this.commonFilterService.GeneralFilter.subscribe(res => {
      //console.log('GeneralFilter')
      this.filters = res;
    });
    this.subscriptions.push(_broadSubGeneralFilter);

    const _broadSubEventIDFilter = this.commonFilterService.GeneralEventIDFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log('filtersWithEventID')
        //this.filterEventIDSelected = true;
        this.filtersWithEventID = res;
        //if (!this.delColSelected && !this.clearAllFiltersBool && (typeof this.filtersWithEventID == 'object' && Object.keys(this.filtersWithEventID).length > 0))
        //  this.LoadVQT('');
      }
    );
    this.subscriptions.push(_broadSubEventIDFilter);

    //Do Auto-refresh - start/stop
    const _broadSubAutoRefresh = this.commonFilterService.componentMethodWithArgCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.AutoRefreshInfo = res;
        //console.log(this.AutoRefreshInfo);

        if (this.AutoRefreshInfo.AutoRefStop) {
          if (this.interval) {
            clearInterval(this.interval);
          }
        }
        else {
          this.interval = setInterval(() => {
            //console.log(this.AutoRefreshInfo.AutoRefStop);
            this.LoadVQT('');
          }, this.AutoRefreshInfo.AutoRefSelected);
        }
      }
    );
    this.subscriptions.push(_broadSubAutoRefresh);

    const _broadStatsRefresh = this.commonFilterService.componentVoiceStatsMethodCalled$.subscribe(
      res => {
        this.commonFilterService.basicVoiceSavedRefresh(0);
        this.getLegend = false;
        this.LoadVQT('');
      }
    );
    this.subscriptions.push(_broadStatsRefresh);
  }

  ngOnInit() {
    //this.LoadVQT();
    this.getLegend = false;
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  parentEvent() {
    //debugger;

    this.title = rsltTypeInTitle(this.rsltType);
    this.childTitleEvent.emit({ title: this.title });
  }

  parentRef(TSSelected) {
    this.TSSelected = parseInt(TSSelected);
    //this.setRsltType();
  }
  parentEventID() {
    this.LoadVQT('');
  }
  parentAutoRef(AutoRefreshInfo) {
    this.TSSelected = parseInt(AutoRefreshInfo.TSSelected);
    this.AutoRefreshInfo = AutoRefreshInfo;
  }

  modifyFilter() {
    //this._router.navigate([{ outlets: { filterPopup: ['filters'], configPopup: null } }]);
    let selectedMainFilterCrieriaName = 'null';
    this.commonFilterService.mainFilter_CriteriaName.subscribe(res => selectedMainFilterCrieriaName = res);
    this._router.navigate([{ outlets: { filterPopup: ['filters', selectedMainFilterCrieriaName], configPopup: null } }]);

    /////// when calling modify search set mainfilter to initial values
    //this.commonFilterService.SetMainFilter(0);// set selected mainfilter id
    //this.commonFilterService.setMFCustDT("");
    //this.commonFilterService.setMFTZON(0);
    ////this.commonFilterService.basicRefresh();
  }

  clearAllFiltersBool = false;
  clearAllFilters() {
    this.LoadVQT('clearAllFilters');
    //this.table.sorter.sortMeta = [];
    //this.table.events.onSort();//IMP- to reset sorting sel cols to none

    //if (this.table.dataFilter.hasFilters()) {
    //  this.table.dataFilter.clear();
    //  //console.log(this.table.dataFilter.hasFilters())
    //  this.table.events.onFilter();
    //  //this.table.events.onFilterClear();
    //  this.clearFilters.emit();
    //}
  }

  AllGeneralFilter = [];
  genArrDel = [];
  filtersWithEventID = {};
  filters = {};
  selectedCallIDOrDevID = false;
  async LoadVQT(delFilterColName, dontReload?) {

    if (delFilterColName == 'VQuad_CallID') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key == 'VQuad_CallID')
          delete this.filters[key];
      }
    }
    else if (delFilterColName == 'clearAllFilters') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key !== this.columnName)
          delete this.filters[key];
      }
    }

    this.hasFilters = Object.keys(this.filters).length <= 1 ? false : true;/// enable /disable clear all filter option under action dropdown

    if (dontReload) {
      //do nothing as already screen loaded
    }
    else {
      if (!this.selectedCallIDOrDevID)
        this.isLoading = true;

      this.url = this.baseUrl + 'CustomStatsConfig/GetVoiceQualityData';
      await this.GetVoiceQualityMainData_Service(delFilterColName, this.AllGeneralFilter, this.filtersWithEventID, this.filters, this.TimestampType, this.columnName).then((res: any) => {
        //console.log(res);
        if (!this.selectedCallIDOrDevID) {
          let rows: any[] = JSON.parse(res) as any[];
          //console.log(rows);
          this.dataSource = rows["lstVoiceQualityVQT"];
          if (rows["lstVoiceQualityVQT"].length > 0)
            this.currPESQVQuadLocationSelected = rows["lstVoiceQualityVQT"][0].VQuad_Location;

          this.dataSourcePolqa = rows["lstVoiceQualityPOLQA"];
          if (rows["lstVoiceQualityPOLQA"].length > 0)
            this.currPOLQAVQuadLocationSelected = rows["lstVoiceQualityPOLQA"][0].VQuad_Location;

          this.dataSourceVBA = rows["lstVoiceQualityVBA"];
          if (rows["lstVoiceQualityVBA"].length > 0)
            this.currVBAVQuadLocationSelected = rows["lstVoiceQualityVBA"][0].VQuad_Location;

          this.BindPieChart(rows["lstPieChartSetting"], null);
        }
      });
      this.isLoading = false;
      this.selectedCallIDOrDevID = false;
    }

    if (delFilterColName != '' && delFilterColName != 'clearAllFilters') {
      this.delColSelected = true;

      this.commonFilterService.setDeleteFilterData('');//reset if delete

      if (delFilterColName == 'VQuad_CallID') {
        this.commonFilterService.setGeneralEventIDFilterData({});
      }

      this.genArrDel = this.AllGeneralFilter.filter(el => {
        return el["ColumnName"] != delFilterColName;
      });
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
    else if (delFilterColName == 'clearAllFilters') {
      this.clearAllFiltersBool = true;

      this.commonFilterService.setClearAllFiltersData();//reset if delete
      this.commonFilterService.setGeneralFilterData(this.filters);
      this.commonFilterService.setGeneralFilterDFData(this.filters);//mainly used in main screen

      this.filtersWithEventID = {};
      this.commonFilterService.setGeneralEventIDFilterData({});

      this.genArrDel = [];
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
  }

  LoadSelectedCallIDVoiceQuality(event, vquadLocation, resultType, collapsed?) {
    if (event != null)
      event.preventDefault();

    if ((resultType == "VQT" && (this.currPESQVQuadLocationSelected != vquadLocation || this.expandedElement == null)) || (resultType == "POLQA" && (this.currPOLQAVQuadLocationSelected != vquadLocation || this.expandedElementPolqa == null))
      || (resultType == "VBA" && (this.currVBAVQuadLocationSelected != vquadLocation || this.expandedElementVBA == null)) || collapsed) {

      if (resultType == "VQT") {
        this.currPESQVQuadLocationSelected = vquadLocation;
        this.currPESQVQuadPhoneIDSelected = "";//reset
      }
      else if (resultType == "POLQA") {
        this.currPOLQAVQuadLocationSelected = vquadLocation;
        this.currPOLQAVQuadPhoneIDSelected = "";//reset
      }
      else {
        this.currVBAVQuadLocationSelected = vquadLocation;
        this.currVBAVQuadPhoneIDSelected = "";//reset
      }

      this.isLoading = true;
      this.url = this.baseUrl + 'CustomStatsConfig/GetVoiceQualityData?strVQuadLocation=' + vquadLocation + '&resultType=' + resultType;

      this.GetVoiceQualityData_Service().subscribe((resCache: any) => {
        //console.log(res);
        if (resCache == "CacheExpired") {
          this.selectedCallIDOrDevID = true;
          this.LoadVQT('');

          this.GetVoiceQualityData_Service().subscribe((res: any) => {
            let rows: any[] = JSON.parse(res) as any[];

            //this.dataSource = rows["lstVoiceQualityVQT"];
            //this.dataSourcePolqa = rows["lstVoiceQualityPOLQA"];
            //this.dataSourceVBA = rows["lstVoiceQualityVBA"];

            this.BindPieChart(rows["lstPieChartSetting"], resultType);
            this.isLoading = false;
          },
            err => {
              this.isLoading = false;
            });
        }
        else {
          let rows: any[] = JSON.parse(resCache) as any[];
          //this.dataSource = rows["lstVoiceQualityVQT"];
          //this.dataSourcePolqa = rows["lstVoiceQualityPOLQA"];
          //this.dataSourceVBA = rows["lstVoiceQualityVBA"];

          this.BindPieChart(rows["lstPieChartSetting"], resultType);
          this.isLoading = false;
        }
      },
        err => {
          this.isLoading = false;
        });
    }
  }

  BindPieChart(pieChartList, resultType) {
    debugger;
    if (this.pieChartVQT != null)
      this.pieChartVQT.destroy();
    if (this.pieChartPOLQA != null)
      this.pieChartPOLQA.destroy();
    if (this.pieChartPOLQAv3 != null)
      this.pieChartPOLQAv3.destroy();
    if (this.pieChartVBA != null)
      this.pieChartVBA.destroy();
    //console.log(pieCharList);
    // this.pieChartLabels.pop();
    let VQTNoData = false;
    
    let POLQANoData = false;
    
    let POLQAv3NoData = false;
    
    let VBANoData = false;
    
    for (let i = 0; i < pieChartList.length; i++) {
      //// VQT piechart
      if (resultType == null || resultType == "VQT") {
        if (pieChartList[i].pieChartName.split('@')[1].includes('VQT')) {
          VQTNoData = true;
          //this.chartNameRTD = pieChartList[i].pieChartName.split('@')[0] + ' (PESQ)';
          //this.pieChartDataRTD = pieChartList[i].pieChartData;
          //this.pieChartColorsRTD[0].backgroundColor = pieChartList[i].pieChartRGBColors;

          //for (let j = 0; j < pieChartList[i].pieChartLabels.length; j++)
          //  this.pieChartLabelsRTD.push(pieChartList[i].pieChartLabels[j]);
          if (document.getElementById("VQTPieChart") != null) {
            this.pieChartVQT = new Chart((<HTMLCanvasElement>document.getElementById("VQTPieChart")).getContext("2d"), {
              type: 'pie',
              data: {
                labels: pieChartList[i].pieChartLabels,
                datasets: [{
                  backgroundColor: pieChartList[i].pieChartRGBColors,
                  data: pieChartList[i].pieChartData
                }]
              },
              options: {
                title: {
                  display: true,
                  text: pieChartList[i].pieChartName
                },
                responsive: true
              }
            });
            this.pieChartVQT.render();
          }
        }
      }

      if (resultType == null || resultType == "POLQA") {
        //// POLQA piechart
        if (pieChartList[i].pieChartName.split('@')[1].includes('POLQA')) {
          POLQANoData = true;
          //this.chartNameOWD = pieChartList[i].pieChartName.split('@')[0] + ' (POLQA MOS)';
          //this.pieChartDataOWD = pieChartList[i].pieChartData;
          //this.pieChartColorsOWD[0].backgroundColor = pieChartList[i].pieChartRGBColors;

          //for (let j = 0; j < pieChartList[i].pieChartLabels.length; j++)
          //  this.pieChartLabelsOWD.push(pieChartList[i].pieChartLabels[j]);
          if (document.getElementById("POLQAPieChart") != null) {
            this.pieChartPOLQA = new Chart((<HTMLCanvasElement>document.getElementById("POLQAPieChart")).getContext("2d"), {
              type: 'pie',
              data: {
                labels: pieChartList[i].pieChartLabels,
                datasets: [{
                  backgroundColor: pieChartList[i].pieChartRGBColors,
                  data: pieChartList[i].pieChartData
                }]
              },
              options: {
                title: {
                  display: true,
                  text: pieChartList[i].pieChartName
                },
                responsive: true
              }
            });
            this.pieChartPOLQA.render();
          }
        }
        //// POLQA v3 piechart
        if (pieChartList[i].pieChartName.split('@')[1].includes('v3')) {
          POLQAv3NoData = true;
          //this.chartNamePDD = pieChartList[i].pieChartName.split('@')[0] + ' (POLQA v3 MOS)';
          //this.pieChartDataPDD = pieChartList[i].pieChartData;
          //this.pieChartColorsPDD[0].backgroundColor = pieChartList[i].pieChartRGBColors;

          //for (let j = 0; j < pieChartList[i].pieChartLabels.length; j++)
          //  this.pieChartLabelsPDD.push(pieChartList[i].pieChartLabels[j]);
          if (document.getElementById("POLQAv3PieChart") != null) {
            this.pieChartPOLQAv3 = new Chart((<HTMLCanvasElement>document.getElementById("POLQAv3PieChart")).getContext("2d"), {
              type: 'pie',
              data: {
                labels: pieChartList[i].pieChartLabels,
                datasets: [{
                  backgroundColor: pieChartList[i].pieChartRGBColors,
                  data: pieChartList[i].pieChartData
                }]
              },
              options: {
                title: {
                  display: true,
                  text: pieChartList[i].pieChartName
                },
                responsive: true
              }
            });
            this.pieChartPOLQAv3.render();
          }
        }
      }

      if (resultType == null || resultType == "VBA") {
        //// VBA piechart
        if (pieChartList[i].pieChartName.split('@')[1].includes('VBA')) {
          VBANoData = true;
          //this.chartNameSNR = pieChartList[i].pieChartName.split('@')[0] + ' (MOS CQ)';
          //this.pieChartDataSNR = pieChartList[i].pieChartData;
          //this.pieChartColorsSNR[0].backgroundColor = pieChartList[i].pieChartRGBColors;

          //for (let j = 0; j < pieChartList[i].pieChartLabels.length; j++)
          //  this.pieChartLabelsSNR.push(pieChartList[i].pieChartLabels[j]);
          if (document.getElementById("VBAPieChart") != null) {
            this.pieChartVBA = new Chart((<HTMLCanvasElement>document.getElementById("VBAPieChart")).getContext("2d"), {
              type: 'pie',
              data: {
                labels: pieChartList[i].pieChartLabels,
                datasets: [{
                  backgroundColor: pieChartList[i].pieChartRGBColors,
                  data: pieChartList[i].pieChartData
                }]
              },
              options: {
                title: {
                  display: true,
                  text: pieChartList[i].pieChartName
                },
                responsive: true
              }
            });
            this.pieChartVBA.render();
          }
        }
      }
    }

    if (document.getElementById("VQTPieChart") != null && !VQTNoData) {
      this.pieChartVQT = new Chart((<HTMLCanvasElement>document.getElementById("VQTPieChart")).getContext("2d"), {
        type: 'pie',
        options: {
          title: {
            display: true,
            text: 'No Data Found (VQT)'
          },
          responsive: true
        }
      });
      this.pieChartVQT.render();
    }

    if (document.getElementById("POLQAPieChart") != null && !POLQANoData) {
      this.pieChartPOLQA = new Chart((<HTMLCanvasElement>document.getElementById("POLQAPieChart")).getContext("2d"), {
        type: 'pie',
        options: {
          title: {
            display: true,
            text: 'No Data Found (POLQA MOS)'
          },
          responsive: true
        }
      });
      this.pieChartPOLQA.render();
    }

    if (document.getElementById("POLQAv3PieChart") != null && !POLQAv3NoData) {
      this.pieChartPOLQAv3 = new Chart((<HTMLCanvasElement>document.getElementById("POLQAv3PieChart")).getContext("2d"), {
        type: 'pie',
        options: {
          title: {
            display: true,
            text: 'No Data Found (POLQA v3)'
          },
          responsive: true
        }
      });
      this.pieChartPOLQAv3.render();
    }

    if (document.getElementById("VBAPieChart") != null && !VBANoData) {
      this.pieChartVBA = new Chart((<HTMLCanvasElement>document.getElementById("VBAPieChart")).getContext("2d"), {
        type: 'pie',
        options: {
          title: {
            display: true,
            text: 'No Data Found (VBA)'
          },
          responsive: true
        }
      });
      this.pieChartVBA.render();
    }

    ////for (let i = 0; i < pieCharList.length; i++)
    ////  this.pieChartColors[0].backgroundColor = pieCharList[i].pieChartRGBColors;

    //if (VQTNoData == false) {
    //  this.chartNameRTD = "";
    //  this.pieChartDataRTD = [];
    //  this.pieChartLabelsRTD = [];
    //}
    //if (POLQANoData == false) {
    //  this.chartNameOWD = "";
    //  this.pieChartDataOWD = [];
    //  this.pieChartLabelsOWD = [];
    //}
    //if (POLQAv3NoData == false) {
    //  this.chartNamePDD = "";
    //  this.pieChartDataPDD = [];
    //  this.pieChartLabelsPDD = [];
    //}
    //if (VBANoData == false) {
    //  this.chartNameSNR = "";
    //  this.pieChartDataSNR = [];
    //  this.pieChartLabelsSNR = [];
    //}
  }

  currPESQVQuadLocationSelected = "";
  currPESQVQuadPhoneIDSelected = "";
  currPOLQAVQuadLocationSelected = "";
  currPOLQAVQuadPhoneIDSelected = "";
  currVBAVQuadLocationSelected = "";
  currVBAVQuadPhoneIDSelected = "";
  GetVoiceQualitExpandedData(event, vquadLocation, resultType, VQuadPhoneID?) {
    if (event != null)
      event.preventDefault();

    if (this.expandedElement != null || this.expandedElementPolqa != null || this.expandedElementVBA != null) {
      this.isLoading = true;
      //console.log(vquadLocation);
      if (VQuadPhoneID) {
        if ((resultType == "VQT" && this.currPESQVQuadPhoneIDSelected != VQuadPhoneID) || (resultType == "POLQA" && this.currPOLQAVQuadPhoneIDSelected != VQuadPhoneID)
          || (resultType == "VBA" && this.currVBAVQuadPhoneIDSelected != VQuadPhoneID)) {

          if (resultType == "VQT")
            this.currPESQVQuadPhoneIDSelected = VQuadPhoneID;
          else if (resultType == "POLQA")
            this.currPOLQAVQuadPhoneIDSelected = VQuadPhoneID;
          else
            this.currVBAVQuadPhoneIDSelected = VQuadPhoneID;

          this.url = this.baseUrl + 'CustomStatsConfig/GetVoiceQualityExpandedData?strVQuadLocation=' + vquadLocation + '&resultType=' + resultType + '&VQuadPhoneID=' + VQuadPhoneID;
        }
        else
          this.isLoading = false;
      }
      else {
        if (resultType == "VQT")
          this.currPESQVQuadLocationSelected = vquadLocation;
        else if (resultType == "POLQA")
          this.currPOLQAVQuadLocationSelected = vquadLocation;
        else
          this.currVBAVQuadLocationSelected = vquadLocation;

        this.url = this.baseUrl + 'CustomStatsConfig/GetVoiceQualityExpandedData?strVQuadLocation=' + vquadLocation + '&resultType=' + resultType;
      }

      if (this.isLoading) {//same phone id not selected again
        this.GetVoiceQualityData_Service().subscribe((resCache: any) => {
          if (resCache == "CacheExpired") {
            this.selectedCallIDOrDevID = true;
            this.LoadVQT('');

            this.GetVoiceQualityData_Service().subscribe((res: any) => {

              let rows: any[] = JSON.parse(res) as any[];

              if (VQuadPhoneID) { }//sub grid already loaded
              else {
                if (resultType == "VQT") {
                  this.dataSourceExpanded = rows["lstVoiceQualityVQT"];//sub grid loading first time
                  if (rows["lstVoiceQualityVQT"].length > 0)
                    this.currPESQVQuadPhoneIDSelected = rows["lstVoiceQualityVQT"][0].VQuad_PhoneID;
                }
                else if (resultType == "POLQA") {
                  this.dataSourceExpandedPolqa = rows["lstVoiceQualityPOLQA"];//sub grid loading first time
                  if (rows["lstVoiceQualityPOLQA"].length > 0)
                    this.currPOLQAVQuadPhoneIDSelected = rows["lstVoiceQualityPOLQA"][0].VQuad_PhoneID;
                }
                else {
                  this.dataSourceExpandedVBA = rows["lstVoiceQualityVBA"];//sub grid loading first time
                  if (rows["lstVoiceQualityVBA"].length > 0)
                    this.currVBAVQuadPhoneIDSelected = rows["lstVoiceQualityVBA"][0].VQuad_PhoneID;
                }                
              }

              this.BindPieChart(rows["lstPieChartSetting"], resultType);//selected or first phone id pie data loading
              this.isLoading = false;
            },
              err => {
                this.isLoading = false;
              });
          }
          else {

            //console.log(resCache);
            let rows: any[] = JSON.parse(resCache) as any[];
            if (VQuadPhoneID) { }//sub grid already loaded
            else {
              if (resultType == "VQT") {
                this.dataSourceExpanded = rows["lstVoiceQualityVQT"];//sub grid loading first time
                if (rows["lstVoiceQualityVQT"].length > 0)
                  this.currPESQVQuadPhoneIDSelected = rows["lstVoiceQualityVQT"][0].VQuad_PhoneID;
              }
              else if (resultType == "POLQA") {
                this.dataSourceExpandedPolqa = rows["lstVoiceQualityPOLQA"];//sub grid loading first time
                if (rows["lstVoiceQualityPOLQA"].length > 0)
                  this.currPOLQAVQuadPhoneIDSelected = rows["lstVoiceQualityPOLQA"][0].VQuad_PhoneID;
              }
              else {
                this.dataSourceExpandedVBA = rows["lstVoiceQualityVBA"];//sub grid loading first time
                if (rows["lstVoiceQualityVBA"].length > 0)
                  this.currVBAVQuadPhoneIDSelected = rows["lstVoiceQualityVBA"][0].VQuad_PhoneID;
              }
            }

            this.BindPieChart(rows["lstPieChartSetting"], resultType);
            this.isLoading = false;
          }
        },
          err => {
            this.isLoading = false;
          });
      }
    }
    else {
      let currVQuadLocationSelected = "";

      if (resultType == "VQT")
        currVQuadLocationSelected = this.currPESQVQuadLocationSelected;
      else if (resultType == "POLQA")
        currVQuadLocationSelected = this.currPOLQAVQuadLocationSelected;
      else
        currVQuadLocationSelected = this.currVBAVQuadLocationSelected;

      this.LoadSelectedCallIDVoiceQuality(null, currVQuadLocationSelected, resultType, true);//switch back to original Call ID Pie graphs
    }
  }

////////////////////////////// get config data
  GetVoiceQualityConfig() {
    this.showLegend = !this.showLegend; // open/hide legend div
    /////if call api for one time only
    if (this.getLegend)
      return;

    this.url = this.baseUrl + 'CustomStatsConfig/GetVoiceQualityPieChartConfig';
    this.GetVoiceQualityData_Service().subscribe((res: any) => {
      //console.log(res);
      let rows: any[] = JSON.parse(res) as any[];
      //console.log(rows);
      this.voiceQualityConfigList = rows;
      this.getLegend = true;
    });
  }

  /////////////////////////////////////////////////////// SERVICES
  GetVoiceQualityData_Service() {
    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, options);
  }

  commonFilter = new CommonFilter();
  generalFilterArray = [];
  dataFilter = new DataFilter();
  async GetVoiceQualityMainData_Service(delFilterColName, AllGeneralFilter, filtersWithEventID, filters, TimestampType, columnName) {
    //let params = new HttpParams()
    //  .set('TSType', TSType)
    //  .set('TSBetween', TSBetween);
    this.generalFilterArray = [];
    this.commonFilter.TimestampType = TimestampType;

    let dbTz = -500;
    //this.commonFilterService.DB_TZ.subscribe(res => {
    //  dbTz = res;
    //});
    //if (dbTz == -500) {//query var col table
    //  await this.service.getDBTimezoneDiff('VquadData').then(res => {
    //    this.commonFilterService.setDBTZFromVarCol(res);
    //    dbTz = res;
    //  });
    //}
    ////console.log(dbTz)

    let MainFilterTZ = 0;
    this.commonFilterService.mainFilterID.subscribe(res => this.commonFilter.MainFilterID = res);// set mainfilter ID
    this.commonFilterService.mfTZ.subscribe(res => MainFilterTZ = res);
    let dbAndBrHrs = -500;
    //if (this.commonFilter.MainFilterID != 0) {
    this.commonFilterService.DB_BRDiff.subscribe(res => {
      dbAndBrHrs = res;
    });
    if (dbAndBrHrs == -500) {//query var col table
      await this.service.getDBAndBrowserDiffHours('VquadData').then(res => {
        this.commonFilterService.setDBAndBrowserHrsDiff(res);
        dbAndBrHrs = res;
      });
    }
    //}

    let dates = formatDate(new Date(Date.now() + -1 * 600 * 1000), dbTz, dbAndBrHrs) + "^" + formatDate(new Date(), dbTz, dbAndBrHrs);//"06/02/2019 11:00:00^06/02/2019 20:00:00";   
    this.commonFilterService.TSBetween.subscribe(res => dates = res);//latest dates selected is set here from service
    //Added to set proper dates here based on range selection
    this.commonFilterService.TSRangeFilter.subscribe(res => { if (res.RangeType !== "custom") { dates = lastDateFunc(res.RangeType, dbTz, dbAndBrHrs) } });//sets start and end dates to latest timestamps based on range type selection - IMP
    //Save current date selection in service to affected when switched to other screens from here - IMP
    this.commonFilterService.setDatesProperties(dates);

    this.generalFilterArray.push({ ColumnName: columnName, Operator: 6, Value: (dates.split('^'))[0], ValueTo: (dates.split('^'))[1], LoggedInUserName: null });
    this.generalFilterArray.push({ ColumnName: columnName, Operator: 13, Value: null, ValueTo: null, LoggedInUserName: null });
    //console.log(this.generalFilterArray)
    let genArr = [];
    let genArrCnt = 0;

    if (delFilterColName != 'clearAllFilters') {
      genArr = AllGeneralFilter.filter(el => {
        return el["ColumnName"].toUpperCase() != columnName.toUpperCase() && (el["RsltType"] == 'pesq' || el["RsltType"] == 'polqa' || el["RsltType"] == 'audio-delay' || el["RsltType"] == 'fax' || el["RsltType"] == '');
      });

      this.commonFilterService.GeneralFilterDF.subscribe(res => {
        //console.log(res)
        filters = res;
      });
    }

    if (typeof filtersWithEventID == 'object' && Object.keys(filtersWithEventID).length > 0) {
      this.dataFilter.filters = filtersWithEventID;
      //console.log(filtersWithEventID)
      genArr = genArr.filter(el => {
        return el["ColumnName"] != 'VQuad_CallID';
      });
      let generalFilterArrayAll = this.dataFilter.getProcessedFiltersArray("ALL");
      genArr = [...genArr, ...generalFilterArrayAll];

      for (const key in filters) {
        if (key == 'VQuad_CallID')
          delete filters[key];
      }
      let generalFilterArrayNew = this.dataFilter.getProcessedFilters("");
      filters = { ...filters, ...generalFilterArrayNew };
    }
    //console.log(genArr)
    //console.log(filters)

    if (delFilterColName != '' && delFilterColName != 'clearAllFilters') {
      //cleared = 1;
      genArr = genArr.filter(el => {
        return el["ColumnName"] != delFilterColName;
      });

      for (const key in filters) {
        if (key == delFilterColName)
          delete filters[key];
      }
    }

    this.generalFilterArray.push(...genArr);
    genArrCnt = genArr.length;

    if (delFilterColName != 'clearAllFilters') {
      let newFilters = {};
      for (const key in filters) {
        if (filters[key].rsltType == 'pesq' || filters[key].rsltType == 'polqa' || filters[key].rsltType == 'audio-delay' || filters[key].rsltType == 'fax' || filters[key].rsltType == '') {
          let value = filters[key].value;
          let matchMode = filters[key].matchMode;
          let valueTo = filters[key].valueTo;
          let type = filters[key].type;
          let rsltType = filters[key].rsltType;
          let title = filters[key].title;
          newFilters[key] = { value, matchMode, valueTo, type, rsltType, title };
        }
      }
      //console.log(newFilters)
      this.commonFilterService.setGeneralFilterData(newFilters);
    }

    let body = JSON.stringify({ commonFilter: this.commonFilter, generalFilterArray: this.generalFilterArray });

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return await this.http.post<any>(this.url, body, options).toPromise();
  }
}

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
  description: string;
}
